<div class="tdg-tab-content mt-0 d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center py-4 action-bar">
        <button type="button" class="tdg-back-btn" (click)="onBackToVersionHistory()">
            <i class="bi bi-arrow-left" aria-hidden="true"></i>
            Back to Version History
        </button>
    </div>
    <div class="compo-content-wrapper">
        <div class="compo-content">
            <div *ngIf="schemas.length || isLoading; else noSchemaData" class="h-100 d-flex flex-column">
                <div class="tdg-header-tabs" *ngIf="schemas.length">
                    <div class="tdg-tab"
                        [ngClass]="{ 'active': tab.testCaseId === selectedSchema.testCaseId || tab.db_name === selectedSchema.db_name }"
                        *ngFor="let tab of schemas" (click)="switchTab(tab)" (keydown)="switchTab(tab)">
                        <img src="assets/images/virtusa-icons/schema-ic.png" alt="tdg-schema">
                        <span> {{ tab.testCaseId || tab.db_name }} </span>
                        @if(tab?.isLoading){
                        <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                        } @else{
                        <img src="assets/images/virtusa-icons/delete.svg" alt="tdg-schema" class="delete-schema"
                            (click)="deleteTable(tab)" (keydown)="deleteTable(tab)">
                        }
                    </div>
                </div>

                <div class="tdg-sub-tab-content d-flex flex-grow-1" [class.ai-open]="showAiSupport">
                    <div class="tdg-table-pane py-4 flex-grow-1 d-flex flex-column overflow-hidden">
                        <div *ngIf="isLoading" class="h-100 v-center">
                            <app-loading [text]="'Saving Data'"></app-loading>
                        </div>
                        <ng-container *ngIf="!isLoading && schemas.length">
                            <div class="tdg-table-toolbar">
                                <app-simple-pager
                                    *ngIf="tableRows.length"
                                    [start]="pagerStart"
                                    [end]="pagerEnd"
                                    [total]="tableRows.length"
                                    [disablePrev]="disablePrevPage"
                                    [disableNext]="disableNextPage"
                                    (prev)="prevPage()"
                                    (next)="nextPage()"
                                ></app-simple-pager>
                                <div class="tdg-table-toolbar-actions">
                                    <button
                                        type="button"
                                        class="btn btn-accello-secondary tdg-action-btn"
                                        [class.active-ai-btn]="showAiSupport"
                                        (click)="openAiSupport()"
                                    >
                                        <img
                                            class="btn-icon btn-icon-default"
                                            src="assets/images/virtusa-icons/ai.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        <img
                                            class="btn-icon btn-icon-active"
                                            src="assets/images/virtusa-icons/ai-dark.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        AI Support
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-accello-secondary tdg-action-btn ms-2"
                                        (click)="saveAndProceed()"
                                    >
                                        <img
                                            class="btn-icon btn-icon-default"
                                            src="assets/images/virtusa-icons/save-icon.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        <img
                                            class="btn-icon btn-icon-active"
                                            src="assets/images/virtusa-icons/save.svg"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                        Save & Next
                                    </button>
                                </div>
                            </div>
                            <app-zorro-table
                                [enableHorizontalScroll]="true"
                                tableId="tdg-dt-source"
                                class="w-100"
                                [columns]="selectedSchema.tables[0].columns"
                                [data]="pagedRows"
                                [options]="tableOptions"
                            >
                            </app-zorro-table>
                        </ng-container>
                    </div>
                    @if (showAiSupport) {
                    <div class="exp-panel-content d-flex flex-column">
                        <div class="px-3 py-3 d-flex flex-column header-section">
                            <div class="ai-panel-title-row">
                                <span class="header-19 main-text">
                                    {{ selectedSchema.db_name }}
                                </span>
                                <button
                                    type="button"
                                    class="accello-icon-btn ai-panel-close"
                                    (click)="closeAiSupport()"
                                    aria-label="Close AI Support"
                                >
                                    <img src="assets/images/virtusa-icons/close.svg" alt="Close" />
                                </button>
                            </div>
                            <span class="regular-text sub-text">
                                AI-powered Support
                            </span>
                        </div>
                        <div class="px-3 py-3 messages d-flex flex-column flex-grow-1">
                            <div class="message-wrapper d-flex" *ngFor="let msg of messages"
                                [ngClass]="{ 'sent': msg.isSent }">
                                <div class="message" [ngClass]="{ 'warning': msg.isWarning }"> {{ msg.text }} </div>
                            </div>
                        </div>
                        <div class="px-3 py-3 prompt-wrapper d-flex flex-column position-relative">
                            <textarea [(ngModel)]="userInput" (keydown.enter)="compose()"
                                [placeholder]="placeholderText"></textarea>
                            <img src="assets/images/virtusa-icons/compose.png" alt="compose" (click)="compose()" (keydown)="compose()">
                        </div>
                    </div>
                    }
                </div>
                <div *ngIf="errorData?.length>0" class="error-div w-100" >
                    <img src="assets/images/virtusa-icons/warning.svg" alt="tip" />
                    <span>{{errorText}}</span>
                    <strong (click)="openValidationError()" (keydown.enter)="openValidationError()">View details</strong>
                </div>
            </div>
            <ng-template #noSchemaData>
                <div class="h-100 v-center">
                    <app-no-data></app-no-data>
                </div>
            </ng-template>
        </div>
    </div>
</div>